<div class="links-container">
  <h2>International & National Racketlon Links</h2>

  <div class="links-group">
    <a href="https://fir.tournamentsoftware.com/" target="_blank">FIR Racketlon Tournaments</a>
    <a href="https://racketlon.co.uk/" target="_blank">UK Racketlon</a>
    <a href="https://www.facebook.com/racketlonNZ/" target="_blank">NZ Racketlon Facebook page</a>
    <a href="https://tabletennis.org.nz/tournaments/ttnz-ranking-system-regulations/ttnz-ranking-and-merit-lists/ttnz-ranking-and-merit-lists" target="_blank">NZ Table Tennis Rankings</a>
    <a href="https://bnz.tournamentsoftware.com/ranking/ranking.aspx?rid=271" target="_blank">NZ Badminton Rankings</a>
    <a href="https://www.mysquash.nz/grading-list" target="_blank">NZ Squash Rankings (login may be required)</a>
    <a href="https://results.matchpoint.kiwi/wtn-ranking" target="_blank">NZ Tennis Rankings</a>
  </div>

  <div class="links-group">
    <a href="https://racketlon.co.uk/" target="_blank">UK Racketlon</a>
    <a href="https://www.racketlon.fr/" target="_blank">Racketlon France</a>
    <a href="https://racketlon.nl/" target="_blank">Racketlon Holland</a>
    <a href="http://www.racketlon.de/turniere/" target="_blank">Racketlon Germany</a>
    <a href="https://racketlon.ch/en" target="_blank">Racketlon Switzerland</a>
    <a href="https://www.racketlon.be/nl/activiteitenkalender" target="_blank">Racketlon Belgium</a>
    <a href="https://www.czechracketlon.cz/turnaje" target="_blank">Czech Racketlon</a>
    <a href="https://www.racketlon.at/turniere/" target="_blank">Racketlon Austria</a>
  </div>

  <div class="links-group">
    <a href="https://streamster.tv/sportarten/racketlon/" target="_blank">Racketlon Streaming</a>
    <a href="https://www.tournamentsoftware.com/find/tournament" target="_blank">Racketlon Tournament Software</a>
  </div>

  <div class="calendar">
    <h2>French 2026 Calendar</h2>
    <img src="assets/images/French Calendar.avif" alt="French Calendar">
  </div>
</div>
